"use client";

import { useEffect, useRef } from "react";
import type { Locale } from "@/lib/i18n";

export default function GoRedirectClient({
  dest,
  watchId,
  channel,
  locale,
}: {
  dest: string;
  watchId: string | null;
  channel: string | null;
  locale: Locale;
}) {
  const didRun = useRef(false);

  useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;

    // The server records the semantic click before rendering this redirect.
    const t = window.setTimeout(() => {
      window.location.assign(dest);
    }, 150);
    return () => window.clearTimeout(t);
  }, [channel, dest, locale, watchId]);

  const copy =
    locale === "es"
      ? {
          title: "Abriendo el proveedor oficial",
          body: "Te estamos enviando al enlace de reserva de tu alerta. MachuPing no vende entradas.",
          fallback: "Si no se redirige automaticamente, abre el enlace de arriba.",
        }
      : locale === "pt"
        ? {
          title: "Abrindo o fornecedor oficial",
          body: "Estamos enviando você ao link de reserva do seu alerta. A MachuPing não vende ingressos.",
          fallback: "Se o redirecionamento não acontecer automaticamente, abra o link acima.",
        }
      : {
          title: "Opening the official provider",
          body: "We are sending you to the booking link from your alert. MachuPing does not sell tickets.",
          fallback: "If you are not redirected, open the link above.",
        };

  return (
    <main className="min-h-screen min-h-[100dvh] flex items-center justify-center px-4">
      <div className="max-w-md w-full rounded-xl border border-border bg-card  p-6">
        <h1 className="text-xl font-semibold tracking-tight">{copy.title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {copy.body}
        </p>
        <a
          className="mt-4 block text-sm font-mono break-all underline underline-offset-4 hover:text-foreground"
          href={dest}
          rel="noreferrer noopener"
        >
          {dest}
        </a>
        <p className="text-xs text-muted-foreground">{copy.fallback}</p>
      </div>
    </main>
  );
}
